// Corsac widgets: icon sprite, product card, price, badges and small DOM helpers.
(function () {
  const CX = (window.CX = window.CX || {});

  CX.$ = (sel, root = document) => root.querySelector(sel);
  CX.$$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  CX.esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  CX.wide = () => window.matchMedia('(min-width: 900px)').matches;
  CX.calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Line icons, 24px grid, drawn for this theme.
  const ICONS = {
    chev: '<path d="m9 6 6 6-6 6"/>',
    down: '<path d="m6 9 6 6 6-6"/>',
    eye: '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z"/><circle cx="12" cy="12" r="2.8"/>',
    ruler: '<path d="M3 15.5 15.5 3 21 8.5 8.5 21Z"/><path d="m7 11.5 1.8 1.8M10 8.5l1.8 1.8M13 5.5l1.8 1.8"/>',
    share: '<circle cx="6" cy="12" r="2.3"/><circle cx="17.5" cy="6" r="2.3"/><circle cx="17.5" cy="18" r="2.3"/><path d="m8.1 10.9 7.3-3.8M8.1 13.1l7.3 3.8"/>',
    filter: '<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>',
    star: '<path d="m12 4 2.4 5 5.4.6-4 3.7 1.1 5.4L12 16l-4.9 2.7 1.1-5.4-4-3.7 5.4-.6Z"/>',
    home: '<path d="M4 11 12 4l8 7"/><path d="M6 10v10h12V10"/>',
    instagram: '<rect x="4" y="4" width="16" height="16" rx="4.5"/><circle cx="12" cy="12" r="3.6"/><path d="M16.8 7.2v.01"/>',
    facebook: '<path d="M14 8.5h2.5V5H14a3.5 3.5 0 0 0-3.5 3.5V11H8v3.5h2.5V20H14v-5.5h2.5L17 11h-3V9a.5.5 0 0 1 .5-.5Z"/>',
    back: '<path d="m15 6-6 6 6 6"/>',
    whatsapp: '<path d="M4.5 19.5 5.6 16A8 8 0 1 1 8.4 18.6l-3.9.9Z"/><path d="M9.3 8.8c.2-.4.6-.4.9-.4.3 0 .5.1.6.4l.6 1.4c.1.2 0 .5-.1.6l-.5.6c.6 1.1 1.5 2 2.6 2.6l.6-.5c.2-.1.4-.2.6-.1l1.4.6c.3.1.4.3.4.6 0 .3 0 .7-.4.9-.6.4-1.5.6-2.6.1a9 9 0 0 1-4.3-4.3c-.4-1-.3-1.9.2-2.4Z"/>',
    search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 20 20"/>',
    bag: '<path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>',
    user: '<circle cx="12" cy="8.5" r="3.5"/><path d="M5 20c.8-3.6 3.6-5.5 7-5.5s6.2 1.9 7 5.5"/>',
    menu: '<path d="M4 8h16M4 16h10"/>',
    close: '<path d="m6 6 12 12M18 6 6 18"/>',
    right: '<path d="M4 12h15M14 7l5 5-5 5"/>',
    left: '<path d="M20 12H5M10 7l-5 5 5 5"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    cash: '<rect x="3" y="6.5" width="18" height="11" rx="1"/><circle cx="12" cy="12" r="2.5"/><path d="M6.5 9.5v.01M17.5 14.5v.01"/>',
    van: '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/>',
    swap: '<path d="M4 9h14l-3.5-3.5M20 15H6l3.5 3.5"/>',
    shop: '<path d="M4 10v10h16V10M3 10l2-5h14l2 5H3Z"/><path d="M10 20v-5h4v5"/>',
    mail: '<rect x="3.5" y="6" width="17" height="12" rx="1"/><path d="m4 7 8 6 8-6"/>',
    phone: '<path d="M7 4h3l1.5 4-2 1.3a10 10 0 0 0 5.2 5.2l1.3-2 4 1.5v3a1 1 0 0 1-1 1A15 15 0 0 1 6 5a1 1 0 0 1 1-1Z"/>',
    pin: '<path d="M12 21s6.5-5.4 6.5-11a6.5 6.5 0 0 0-13 0c0 5.6 6.5 11 6.5 11Z"/><circle cx="12" cy="10" r="2.3"/>',
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
  };
  CX.icon = (name, cls = '') => `<svg class="cx-icon ${cls}" viewBox="0 0 24 24" aria-hidden="true">${ICONS[name] || ''}</svg>`;

  // Button / link labels that roll on hover.
  CX.roll = (text) => `<span class="cx-roll" data-text="${CX.esc(text)}"><span>${CX.esc(text)}</span></span>`;

  CX.price = (p) => {
    if (p.compare && p.compare > p.price) return `<span class="cx-price cx-price--sale"><span>${CX.money(p.price)}</span><s>${CX.money(p.compare)}</s></span>`;
    return `<span class="cx-price"><span>${CX.money(p.price)}</span></span>`;
  };

  CX.badges = (p) => {
    const out = [];
    if (!p.inStock) out.push('<span class="cx-badge cx-badge--out">Sold out</span>');
    else if (p.compare && p.compare > p.price) out.push(`<span class="cx-badge cx-badge--sale">${Math.round((1 - p.price / p.compare) * 100)}% OFF</span>`);
    return out.length ? `<div class="cx-card__badges">${out.join('')}</div>` : '';
  };

  // Display name: drop the colour suffix after the dash; the colour goes in the meta line.
  CX.splitName = (name) => {
    const m = String(name).split(/\s+[–-]\s+/);
    return { title: m[0], tone: m.slice(1).join(' – ') };
  };

  // Responsive <img> for a product or collection photo.
  CX.pic = (url, { alt = '', sizes = '100vw', w = 720, lazy = true, cls = '', high = false } = {}) => {
    const set = CX.srcset(url);
    return `<img src="${CX.img(url, w)}"${set ? ` srcset="${set}" sizes="${sizes}"` : ''} alt="${CX.esc(alt)}"${lazy ? ' loading="lazy"' : ''}${high ? ' fetchpriority="high"' : ''} decoding="async"${cls ? ` class="${cls}"` : ''}>`;
  };

  const CARD_SIZES = '(min-width: 1100px) 25vw, (min-width: 768px) 33vw, 50vw';
  // Star rating from the product's review metafields (nothing when it has no reviews).
  CX.stars = (p, small) => (p.reviews > 0 ? `<span class="cx-stars${small ? ' cx-stars--sm' : ''}" style="--r:${p.rating}" aria-label="Rated ${p.rating} out of 5"><i></i><span>(${p.reviews})</span></span>` : '');
  // Product card, live skeleton: photo (+ second photo on hover), badge, quick view, sizes on hover, name, colours, price.
  // Product card. Two styles (theme setting "Card style"):
  //  classic  - quick-view eye and a sizes strip over the photo;
  //  quickadd - a Quick add bar under the details: one tap adds a one-size product, otherwise it opens the sizes in place.
  // Options: rank (number shown on the photo, e.g. best sellers), lead (the large first tile in a grid).
  CX.card = (p, { reveal = true, delay = 0, sizes = CARD_SIZES, rank = 0, lead = false } = {}) => {
    const badge = CX.badge(p);
    const o = CX.cardOptions || {};
    const qa = o.style === 'quickadd';
    const second = o.hover !== false && p.gallery[1] && p.gallery[1] !== p.gallery[0] ? CX.pic(p.gallery[1], { sizes }) : '';
    const n = (p.variants || []).length;
    const sz = (p.sizes || []).filter(Boolean);
    const quick = !qa ? '' : !p.inStock
      ? '<div class="cx-qa"><span class="cx-qa__out">Sold out</span></div>'
      : `<div class="cx-qa" data-cx-qa="${CX.esc(p.id)}">
          <button class="cx-qa__btn" data-cx-qa-open aria-haspopup="dialog">${CX.icon('plus', 'cx-icon--sm')}<span>${sz.length > 1 || p.variants ? 'Quick add' : 'Add to cart'}</span></button>
        </div>`;
    return `<article class="cx-card${qa ? ' cx-card--qa' : ''}${lead ? ' cx-card--lead' : ''}${rank ? ' cx-card--ranked' : ''}"${reveal ? ` data-cx-unveil style="--d:${delay}ms"` : ''}>
      <div class="cx-card__media">
        <a href="${CX.routes.product(p.id)}" aria-label="${CX.esc(p.name)}">${CX.pic(p.gallery[0], { alt: p.name, sizes: lead ? '(min-width: 1100px) 40vw, 100vw' : sizes })}${second}</a>
        ${rank ? `<span class="cx-card__rank" aria-label="Number ${rank}">${String(rank).padStart(2, '0')}</span>` : ''}
        ${badge ? `<span class="cx-badge${p.inStock ? ' cx-badge--sale' : ' cx-badge--out'} cx-card__badge">${badge}</span>` : ''}
        ${!qa && o.quickView !== false ? `<button class="cx-card__eye" data-cx-quick="${CX.esc(p.id)}" aria-label="Quick view ${CX.esc(p.name)}">${CX.icon('eye', 'cx-icon--sm')}</button>` : ''}
        ${!qa && o.sizes !== false && sz.length ? `<div class="cx-card__sizes" aria-hidden="true"><span>Size</span>${sz.map((x) => `<i${CX.isSold(p, x) ? ' class="is-sold"' : ''}>${CX.esc(x)}</i>`).join('')}</div>` : ''}
      </div>
      <div class="cx-card__body">
        <h3 class="cx-card__name"><a href="${CX.routes.product(p.id)}">${CX.esc(p.name)}</a></h3>
        ${n ? `<p class="cx-card__meta">${n} ${CX.variantLabel(p) === 'Colour' ? 'colours' : 'styles'}</p>` : ''}
        ${o.stars !== false ? CX.stars(p, true) : ''}
        ${CX.price(p)}
      </div>
      ${quick}
    </article>`;
  };

  // Quick add: open the sizes, add a size, or add a one-size product straight away.
  document.addEventListener('click', (e) => {
    const box = e.target.closest('[data-cx-qa]');
    if (!box) {
      document.querySelectorAll('.cx-qa.is-open').forEach((b) => { b.classList.remove('is-open'); b.querySelector('[data-cx-qa-open]').setAttribute('aria-expanded', 'false'); });
      return;
    }
    const p = CX.byId(box.dataset.cxQa);
    if (!p) return;
    const added = (size) => {
      box.classList.remove('is-open', 'is-busy');
      const btn = box.querySelector('[data-cx-qa-open] span');
      if (CX.cartError) { CX.toast(CX.esc(CX.cartError)); return; }
      btn.textContent = 'Added';
      box.classList.add('is-done');
      setTimeout(() => { box.classList.remove('is-done'); btn.textContent = (p.sizes || []).filter(Boolean).length > 1 ? 'Quick add' : 'Add to cart'; }, 1800);
      CX.toast(`${CX.icon('check', 'cx-icon--sm')} Added to cart${size ? ` · size ${CX.esc(size)}` : ''} <button class="cx-toast__link" data-cx-open="cart">View cart</button>`);
    };
    const opener = e.target.closest('[data-cx-qa-open]');
    if (opener) {
      const sz = (p.sizes || []).filter(Boolean);
      if (sz.length > 1 || p.variants) {
        if (CX.quickView) CX.quickView(p.id);
      } else {
        box.classList.add('is-busy');
        CX.cart.add(p.id, sz[0] || '').then(() => added(sz[0]));
      }
      return;
    }
    const size = e.target.closest('[data-cx-qa-size]');
    if (size && !size.disabled) {
      box.classList.add('is-busy');
      CX.cart.add(p.id, size.dataset.cxQaSize).then(() => added(size.dataset.cxQaSize));
    }
  });

  // Small toast at the bottom of the screen.
  let toastTimer;
  CX.toast = (html) => {
    let el = CX.$('.cx-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cx-toast';
      el.setAttribute('role', 'status');
      document.body.append(el);
    }
    el.innerHTML = html;
    requestAnimationFrame(() => el.classList.add('is-on'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2600);
  };
})();
